/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Contract_Cancel_EffectInputs */



/**
* | output |
* | --- |
* | "Use this when the deal fell through. The contract will never start, and the organization stays switched off as an ordinary suspended organization, which you ..." |
*
* @param {Partner_Org_Contract_Cancel_EffectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_cancel_effect = /** @type {((inputs?: Partner_Org_Contract_Cancel_EffectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Cancel_EffectInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Für den Fall, dass das Geschäft nicht zustande kommt. Der Vertrag startet nie, und die Organisation bleibt als gewöhnlich gesperrte Organisation abgeschaltet — Sie können sie entsperren oder so belassen. Dies kann nicht rückgängig gemacht werden.")
	return /** @type {LocalizedString} */ ("Use this when the deal fell through. The contract will never start, and the organization stays switched off as an ordinary suspended organization, which you can unfreeze or leave. This cannot be undone.")
});